<ng-container *transloco="let t; read: 'installations.detail'">
  @if (vm$ | async; as vm) {
    <div class="componentContainer">
      <section class="xs12col componentHeader">
        @if (isNew) {
          <h1>{{ t("createTitle") }}</h1>
        }
        @if (!isNew) {
          @if (vm.installation; as installation) {
            <h1>
              {{ t("modifyTitle") }} {{ installation.name }} {{ t("of") }}
              {{ installation.companyName }}
            </h1>
          }
        }
      </section>
      <section class="oneCol">
        <div class="xs12col flexColumn">
          <div class="boxContainer">
            <div class="box">
              <form [formGroup]="installationForm">
                @if ("Permissions.Installations.Update" | permission) {
                  <div class="xs12col m6col">
                    <fieldset
                      class="fieldsetContainer margin-right-large flexColumn"
                    >
                      <kendo-formfield>
                        <kendo-label [text]="t('company')">*</kendo-label>
                        <kendo-dropdownlist
                          [data]="vm.companies"
                          textField="name"
                          valueField="id"
                          [defaultItem]="{ id: null, name: t('chooseClient') }"
                          formControlName="companyId"
                          [valuePrimitive]="true"
                          [readonly]="!isNew"
                          (valueChange)="onCompanyChange($event)"
                        >
                        </kendo-dropdownlist>
                      </kendo-formfield>
                      <kendo-formfield>
                        <kendo-label [text]="t('name')">*</kendo-label>
                        <kendo-textbox
                          formControlName="name"
                          [readonly]="
                            !('Permissions.Installations.Create' | permission)
                          "
                        ></kendo-textbox>
                      </kendo-formfield>
                    </fieldset>
                  </div>
                }
                <div class="xs12col m6col flexColumn" [hidden]="isNew">
                  <fieldset class="fieldsetContainer">
                    @if (
                      ("Permissions.Installations.Update" | permission) &&
                      vm?.images?.length == 0
                    ) {
                      <div class="titleAdd">
                        <h2>{{ t("image") }}</h2>
                        <span
                          [attr.tooltip]="t('upload.tooltipPicture')"
                          flow="right"
                          class="tooltipContainer"
                        >
                          <img
                            class="tooltipIcon"
                            src="../assets/icons/information-icon.svg"
                          />
                        </span>
                      </div>
                    }
                    <kendo-upload
                      kendoButton
                      (upload)="uploadAttachment($event)"
                      [restrictions]="restrictions"
                      [multiple]="false"
                      [ngClass]="{ uploading: vm.isUploading }"
                      d
                      loadingIndication="/attachment/uploadAttachment"
                      [hidden]="
                        !('Permissions.Installations.Update' | permission) ||
                        vm?.images?.length > 0
                      "
                    >
                      <kendo-upload-messages
                        [dropFilesHere]="t('upload.dropZone')"
                        [select]="
                          vm.isUploading ? '&#x21bb;' : t('upload.button')
                        "
                      >
                      </kendo-upload-messages>
                    </kendo-upload>
                    @for (image of vm.images; track image) {
                      <div class="attachmentItem">
                        <a
                          (click)="deleteAttachment(image.id)"
                          class="deleteIcon"
                          [hidden]="
                            !('Permissions.Installations.Update' | permission)
                          "
                          ><img src="../../../assets/icons/close-icon.svg"
                        /></a>
                        <img [src]="image.data" class="image" />
                      </div>
                    }
                  </fieldset>
                </div>
                <div class="xs12col m6col flexColumn leftCol">
                  <div class="deviceTitle xs12col">
                    <h2>{{ t("devices") }}</h2>
                  </div>
                  <p>
                    <strong>{{ t("linkedDevices") }}</strong>
                  </p>
                  <div formArrayName="devices" class="availableDevices">
                    @for (
                      device of devices.controls;
                      track device;
                      let i = $index
                    ) {
                      <div [formGroupName]="i" class="availableDevice linked">
                        <div>
                          <label>{{ t("manufacturer") }}</label>
                          <input
                            class="removeInputStyles"
                            formControlName="manufacturerName"
                            [readonly]="true"
                          />
                        </div>
                        <div>
                          <label>{{ t("tagNumber") }}</label>
                          <input
                            class="removeInputStyles"
                            formControlName="tagNumber"
                            [readonly]="true"
                          />
                        </div>
                        <div>
                          <label>{{ t("type") }}</label>
                          <input
                            class="removeInputStyles"
                            formControlName="type"
                            [readonly]="true"
                          />
                        </div>
                        <div>
                          <label>{{ t("serialNumber") }}</label>
                          <input
                            class="removeInputStyles"
                            formControlName="serialNumber"
                            [readonly]="true"
                          />
                        </div>
                        <div class="actions">
                          @if ("Permissions.Devices.Update" | permission) {
                            <a
                              [routerLink]="[
                                '/devices-admin/',
                                device.value.id,
                              ]"
                              [attr.tooltip]="t('openDevice')"
                              flow="up"
                              class="actionIcon"
                            >
                              <img
                                src="../../../assets/icons/open-link-icon.svg"
                              />
                            </a>
                          }
                          @if (!("Permissions.Devices.Update" | permission)) {
                            <a
                              [routerLink]="['/devices/', device.value.id]"
                              [attr.tooltip]="t('openDevice')"
                              flow="up"
                              class="actionIcon"
                            >
                              <img
                                src="../../../assets/icons/open-link-icon.svg"
                              />
                            </a>
                          }
                          <button
                            kendoButton
                            class="buttonSecondary"
                            [attr.tooltip]="t('delete')"
                            flow="up"
                            [hidden]="
                              !('Permissions.Installations.Update' | permission)
                            "
                            (click)="removeDevice(device.value.id, i)"
                          >
                            <img src="../../../assets/icons/delete-icon.svg" />
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div
                  class="xs12col m6col flexColumn rightCol"
                  [hidden]="!('Permissions.Installations.Update' | permission)"
                >
                  <span class="tooltipContainer">
                    <p>
                      <strong>{{ t("availableDevices") }}</strong>
                    </p>
                    <span
                      [attr.tooltip]="t('tooltipSearch')"
                      flow="right"
                      class="tooltipContainer"
                    >
                      <img
                        class="tooltipIcon"
                        src="../assets/icons/information-icon.svg"
                      />
                    </span>
                  </span>
                  <form
                    [formGroup]="filterForm"
                    (ngSubmit)="onSubmit(vm.searchRequest)"
                    class="searchForm"
                  >
                    <kendo-formfield class="xs12col s12col m6col">
                      <div class="searchInputContainer">
                        <kendo-textbox
                          formControlName="keyword"
                          class="searchTextField"
                        >
                        </kendo-textbox>
                      </div>
                    </kendo-formfield>
                    <div class="buttonContainer flex-wrap searchButton">
                      <button
                        [disabled]="filterForm.invalid || filterForm.pristine"
                        type="submit"
                        kendoButton
                        class="buttonPrimary"
                      >
                        {{ t("filterSearch") }}
                      </button>
                    </div>
                    <div
                      class="buttonContainer margin-bottom-large flex-wrap searchButton"
                    >
                      @if (showReset) {
                        <button
                          type="button"
                          (click)="resetFilter()"
                          class="buttonSecondary"
                        >
                          {{ t("resetFilter") }}
                        </button>
                      }
                    </div>
                  </form>
                  <kendo-grid
                    [data]="vm.availableDevicesForInstallation"
                    [skip]="vm.gridState.skip"
                    [pageSize]="vm.gridState.pageSize"
                    [pageable]="true"
                    [loading]="loading"
                    (pageChange)="pageChangeSub$.next($event)"
                  >
                    <!-- DESKTOP GRID -->
                    <kendo-grid-column
                      field="deviceManufacturerId"
                      [title]="t('device.manufacturer')"
                      media="(min-width: 993px)"
                    >
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.manufacturer?.name }}
                      </ng-template>
                      <ng-template let-formGroup="formGroup">
                        <kendo-textbox
                          [formControl]="formGroup.get('deviceManufacturerId')"
                        ></kendo-textbox>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                      field="tagNumber"
                      [title]="t('device.tagNumber')"
                      media="(min-width: 993px)"
                    >
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.tagNumber }}
                      </ng-template>
                      <ng-template let-formGroup="formGroup">
                        <kendo-textbox
                          [formControl]="formGroup.get('tagNumber')"
                        ></kendo-textbox>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                      field="type"
                      [title]="t('device.type')"
                      media="(min-width: 993px)"
                    >
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.type }}
                      </ng-template>
                      <ng-template let-formGroup="formGroup">
                        <kendo-textbox
                          [formControl]="formGroup.get('type')"
                        ></kendo-textbox>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                      field="serialNumber"
                      [title]="t('device.serialNumber')"
                      media="(min-width: 993px)"
                    >
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.serialNumber }}
                      </ng-template>
                      <ng-template let-formGroup="formGroup">
                        <kendo-textbox
                          [formControl]="formGroup.get('serialNumber')"
                        ></kendo-textbox>
                      </ng-template>
                    </kendo-grid-column>
                    <!-- MOBILE GRID -->
                    <kendo-grid-column media="(max-width: 992px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">
                          {{ t("device.manufacturer") }}
                        </h4>
                        <span>{{ dataItem.manufacturer?.name }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column media="(max-width: 992px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">
                          {{ t("device.tagNumber") }}
                        </h4>
                        <span>{{ dataItem.tagNumber }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column media="(max-width: 992px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">
                          {{ t("device.type") }}
                        </h4>
                        <span>{{ dataItem.type }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column media="(max-width: 992px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">
                          {{ t("device.serialNumber") }}
                        </h4>
                        <span>{{ dataItem.serialNumber }}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-command-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <button
                          kendoButton
                          class="addIcon small"
                          [hidden]="
                            !('Permissions.Installations.Update' | permission)
                          "
                          loadingIndication="/revisions/addDevicesToRevision/"
                          (click)="
                            linkDevice(
                              dataItem.id,
                              dataItem.serialNumber,
                              dataItem.tagNumber,
                              dataItem.type,
                              dataItem.manufacturer?.name,
                              dataItem.deviceLocation?.name
                            )
                          "
                        >
                          <span class="icon">
                            <img src="../../../assets/icons/add-icon.svg" />
                          </span>
                        </button>
                      </ng-template>
                    </kendo-grid-command-column>
                    <!-- Paging -->
                    <ng-template
                      let-totalPages="totalPages"
                      let-currentPage="currentPage"
                      kendoPagerTemplate
                    >
                      <div class="flex gridPagination">
                        <div class="flex flexDirRow gridRow">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-numeric-buttons
                            [buttonCount]="5"
                          ></kendo-pager-numeric-buttons>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        </div>
                        <div class="gridRow">
                          <kendo-buttongroup
                            [selection]="'single'"
                            id="pageBtnGroup"
                          >
                            <button
                              (click)="
                                pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Small,
                                })
                              "
                              kendoButton
                              [selected]="
                                vm.gridState.pageSize === pageSizes.Small
                              "
                              [toggleable]="true"
                            >
                              {{ pageSizes.Small }}
                            </button>
                            <button
                              (click)="
                                pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Medium,
                                })
                              "
                              kendoButton
                              [selected]="
                                vm.gridState.pageSize === pageSizes.Medium
                              "
                              [toggleable]="true"
                            >
                              {{ pageSizes.Medium }}
                            </button>
                            <button
                              (click)="
                                pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Large,
                                })
                              "
                              kendoButton
                              [selected]="
                                vm.gridState.pageSize === pageSizes.Large
                              "
                              [toggleable]="true"
                            >
                              {{ pageSizes.Large }}
                            </button>
                          </kendo-buttongroup>
                          @if (reloadResults) {
                            <button
                              kendoButton
                              [title]="t('refresh')"
                              class="reloadIcon"
                              (click)="searchRequest$.next(vm.searchRequest)"
                            >
                              <img
                                class="actionIcon"
                                src="../assets/icons/reload.svg"
                              />
                            </button>
                          }
                        </div>
                      </div>
                    </ng-template>
                    <ng-template kendoGridNoRecordsTemplate>
                      <div class="text pl">{{ t("noResults") }}</div>
                    </ng-template>
                    <ng-template kendoGridLoadingTemplate>
                      <div class="k-loading-color"></div>
                      <div class="loading-container">
                        <kendo-loader
                          type="converging-spinner"
                          size="large"
                        ></kendo-loader>
                      </div>
                    </ng-template>
                  </kendo-grid>
                </div>

                <div class="buttonContainer">
                  <button
                    kendoButton
                    class="buttonPrimary"
                    type="submit"
                    (click)="saveChanges()"
                    [hidden]="
                      !('Permissions.Installations.Update' | permission)
                    "
                    [disabled]="
                      installationForm?.invalid || !installationForm?.dirty
                    "
                  >
                    {{ isNew ? t("submit") : t("save") }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <button
            type="delete"
            (click)="deletionDialogOpen()"
            class="buttonSecondary delete padding-top-medium padding-bottom-medium"
            [hidden]="
              isNew || !('Permissions.Installations.Delete' | permission)
            "
          >
            {{ t("delete") }}
          </button>
        </div>
      </section>
      @if (deletionDialogOpened) {
        <kendo-dialog
          title="{{ t('confirmDeletion') }}"
          (close)="deletionDialogClose('cancel')"
          [minWidth]="250"
          [width]="450"
        >
          <p style="margin: 30px; text-align: center">
            {{ t("deletionMessage") }}
          </p>
          <kendo-dialog-actions>
            <button kendoButton (click)="deletionDialogClose('cancel')">
              {{ t("cancel") }}
            </button>
            <button
              kendoButton
              (click)="deletionDialogClose('delete')"
              themeColor="primary"
            >
              {{ t("delete") }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
    </div>
  }
</ng-container>
